import { ReactElement } from "react";
import { ICentralMaintenance, IPanelProps } from "./types";
import { cloneObject } from "../../../../system/utils";
import RowComponent from "../../components/rowComponent";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import TextField from "@mui/material/TextField";

const MaintenancePanel = ({ value, property, onChange }: IPanelProps<ICentralMaintenance>): ReactElement => {

  const onChangeValue = (prop: keyof ICentralMaintenance, selectedValue: any) => {
    const newValue = cloneObject(value);

    newValue[prop].value = selectedValue;
    onChange(property, newValue);
  };

  const onChangeComment = (prop: keyof ICentralMaintenance, comment: string) => {
    const newValue = cloneObject(value);

    newValue[prop].comment = comment;
    onChange(property, newValue);
  };

  return (
    <div className="display-flex-column gap-1 p-1">
      <RowComponent title="Air Compressors" ratio={.2} >
        <div className="row-content-2">
          <ToggleButtonGroup
            fullWidth={true}
            value={value.airCompressors.value}
            exclusive={true}
            onChange={(_event, selectedValue) => onChangeValue("airCompressors", selectedValue)}>
            <ToggleButton value={true} >OK</ToggleButton>
            <ToggleButton value={false} >NOT OK</ToggleButton>
          </ToggleButtonGroup>
          <TextField
            variant="outlined"
            placeholder="to be filled..."
            multiline={true}
            minRows={4}
            maxRows={4}
            value = {value.airCompressors.comment}
            fullWidth={true}
            onChange={event => onChangeComment("airCompressors", event.target.value)}
          />
        </div>
      </RowComponent>
      <RowComponent title="Cooling Tower" ratio={.2} >
        <div className="row-content-2">
          <ToggleButtonGroup
            fullWidth={true}
            value={value.coolingTower.value}
            exclusive={true}
            onChange={(_event, selectedValue) => onChangeValue("coolingTower", selectedValue)}>
            <ToggleButton value={true} >OK</ToggleButton>
            <ToggleButton value={false} >NOT OK</ToggleButton>
          </ToggleButtonGroup>
          <TextField
            variant="outlined"
            placeholder="to be filled..."
            multiline={true}
            minRows={4}
            maxRows={4}
            value = {value.coolingTower.comment}
            fullWidth={true}
            onChange={event => onChangeComment("coolingTower", event.target.value)}
          />
        </div>
      </RowComponent>
      <RowComponent title="HVAC" ratio={.2} >
        <div className="row-content-2">
          <ToggleButtonGroup
            fullWidth={true}
            value={value.hvac.value}
            exclusive={true}
            onChange={(_event, selectedValue) => onChangeValue("hvac", selectedValue)}>
            <ToggleButton value={true} >OK</ToggleButton>
            <ToggleButton value={false} >NOT OK</ToggleButton>
          </ToggleButtonGroup>
          <TextField
            variant="outlined"
            placeholder="to be filled..."
            multiline={true}
            minRows={4}
            maxRows={4}
            value = {value.hvac.comment}
            fullWidth={true}
            onChange={event => onChangeComment("hvac", event.target.value)}
          />
        </div>
      </RowComponent>
    </div>
  );
};

export default MaintenancePanel;